import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import { store } from "./store";
import { WebSocketProvider } from "./context/WebSocketContext";
import "./index.css";
import App from "./App";
import { msalInstance } from "./auth/msalInstance";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const content = (
  <WebSocketProvider>
    <App />
  </WebSocketProvider>
);

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>{content}</MsalProvider>
      ) : (
        content
      )}
    </Provider>
  </StrictMode>,
);
